import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/app/contexts/UserContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Manrope\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"manrope\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Noto_Sans_Arabic\",\"arguments\":[{\"subsets\":[\"arabic\"]}],\"variableName\":\"notoSansArabic\"}");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@mantine/core/styles.css");
;
import(/* webpackMode: "eager" */ "/app/styles/globals.css");
